import React, { Component, Fragment } from 'react';

import classnames from 'classnames';
import _ from 'lodash';

import ColorPicker from 'components/ColorPicker';
import ButtonBorderChanger from 'components/ButtonBorderChanger';

const SUBMIT_DELAY = 500;

class ImageLinkStyles extends Component {
  acceptImageLinkStyles = (id, value, type, typeValue) => {
    const { acceptImageLinkStyles } = this.props;
    let body = {};
    body[id] = value;

    if (type) {
      body[type] = typeValue;
    }

    acceptImageLinkStyles(body);
  };

  handleDebounce = _.debounce((id, value) => {
    this.acceptImageLinkStyles(id, value);
  }, SUBMIT_DELAY);

  render() {
    const { defaultImageLinkValues } = this.props;

    return (
      <Fragment>
        {!defaultImageLinkValues.similar_to_button > 0 && (
          <div>
            <h2 className="h2-title">Image link</h2>
            <div className="separator-line m-b-40" />
            <div className="style-form">
              <div className="style-form__row">
                <ButtonBorderChanger
                  header="Image border thickness"
                  defaultValue={defaultImageLinkValues.border_thickness}
                  handleChange={value =>
                    this.handleDebounce('border_thickness', value)
                  }
                  min={0}
                  max={10}
                />
                <ButtonBorderChanger
                  header="Image border radius"
                  defaultValue={defaultImageLinkValues.border_radius}
                  handleChange={value =>
                    this.handleDebounce('border_radius', value)
                  }
                  min={0}
                  max={10}
                />
              </div>
              <div className="style-form__row">
                <div className="style-form__col bg flex">
                  <div className="style-form__subtitle top">Image border</div>
                  <div className="bg-images-group">
                    <div className="bg-image-itm">
                      <label
                        className={classnames('bg-image-itm__label', {
                          'bg-image-itm__label__checked':
                            defaultImageLinkValues.border_type === 'color',
                        })}>
                        <ColorPicker
                          color={defaultImageLinkValues.border_value}
                          acceptColor={color =>
                            this.acceptImageLinkStyles(
                              'border_value',
                              color,
                              'border_type',
                              'color',
                            )
                          }
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="style-form m-b-50">
          <div className="separator-line" />
          <div className="style-form__row">
            <div className="switch-block full-width">
              <div className="switch-block__text">
                Image links style matches buttons style
              </div>
              <div className="checkbox-switch">
                <input
                  name="profilesWithContacts"
                  type="checkbox"
                  className="checkbox-switch__input"
                  checked={defaultImageLinkValues.similar_to_button}
                  value={!defaultImageLinkValues.similar_to_button}
                  onChange={e => {
                    this.handleDebounce('similar_to_button', e.target.value);
                  }}
                  id="image-links-style-matches"
                />
                <label
                  htmlFor="image-links-style-matches"
                  className="checkbox-switch__label"
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ImageLinkStyles;



// WEBPACK FOOTER //
// ./src/scenes/Styles/ImageLinkStyles.js